import { render } from "./ExportRetributionsModal.vue?vue&type=template&id=488754c4"
import script from "./ExportRetributionsModal.vue?vue&type=script&lang=js"
export * from "./ExportRetributionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__